<template>
  <transition name="forward">
    <div class="recommend" v-show="show">
      <div class="recommend-content">
        <scroller>
          <div class="top-Nav">
            <div class="nav-Row"><img src="../../assets/image/flower-left.svg"></div>
            <div class="nav-Row font1-1">这样搭配，更好吃~</div>
            <div class="nav-Row"><img src="../../assets/image/flower-right.svg"></div>
          </div>
          <div class="recom-Con" v-for="recommend in recommendMenu" v-if="recommend.menuItem.length>0">
            <div class="recom-title font1-2">{{recommend.title}}</div>
            <div class="recom-Icon">
              <img src="../../assets/image/recommeIcon.svg">
            </div>
            <div class="reason border-brown border-radius-5">
              <div class="width30 reason-row color-brown font0-9 line-right-lightYellow">搭配理由</div>
              <div class="reason-row flex-1 color-deepGray font0-9">{{recommend.reason}}</div>
            </div>
            <!--每一道菜-->
            <div v-for="item in recommend.menuItem" @click="clickDetail(item)">
              <!--有图-->
              <div class="food-content border-gray border-radius-5" v-if="item.picMode>0">
                <img src="../../assets/image/gou-01.svg" width="20" v-show="item.check>0" class="order_identifying" >
                <div class="food-mainInfo">
                  <div class="food-pic"><img :src="item.picPath" style="width: 100px; height: auto;"></div>
                  <div class="food-Name">
                    <div class="food-Name-row color-black">{{item.name}}
                      <img v-for="icon in item.iconPath" :src="icon" width="20">
                    </div>
                    <div class="food-Name-tips color-lightGray font0-9" style="-webkit-box-orient: vertical;">{{item.desc}}</div>
                  </div>
                </div>
                <div class="price-Content">
                  <div class="price-One color-orange">
                    <!--<span class="font0-8">￥</span>-->
                    <span>{{item.price}}元/份</span>
                  </div>
                  <div class="price-One color-blue">
                    <img src="../../assets/image/vipIco.svg"width="18" alt="会员价" v-if="item.memberprice<item.price">
                    <span class="font0-8 padding-left-5" v-if="item.memberprice<item.price">元</span>
                    <span v-if="item.memberprice<item.price">{{item.memberprice}}元/份</span>
                  </div>
                  <div class="price-One">
                    <div class="view-info border-brown border-radius-30 color-brown">查看详情</div>
                  </div>
                </div>
                <div style="position: absolute;bottom:60px;left:39%;" v-if="item.isSaleout">
                  <img src="../../assets/image/soldout.svg" width="65">
                </div>
              </div>
              <!--无图-->
              <div class="food-content border-gray border-radius-5" v-if="item.picMode===0">
                <img src="../../assets/image/gou-01.svg" width="20" v-show="item.check>0" class="order_identifying" >
                <div class="food-nopic">
                  <div class="food-nopic-title font1-2 color-black">
                    {{item.name}}
                    <img v-for="icon in item.iconPath" :src="icon" width="20">
                  </div>
                  <div class="price-Content">
                    <div class="price-One color-orange">
                      <!--<span class="font0-8">￥</span>-->
                      <span>{{item.price}}元/份</span>
                    </div>
                    <div class="price-One color-blue">
                      <img src="../../assets/image/vipIco.svg" width="18" alt="会员价" v-if="item.memberprice<item.price">
                      <span class="font0-8 padding-left-5" v-if="item.memberprice<item.price">元</span>
                      <span v-if="item.memberprice<item.price">{{item.memberprice}}元/份</span>
                    </div>
                    <div class="price-One">
                      <div class="view-info border-brown border-radius-30 color-brown">查看详情</div>
                    </div>
                  </div>
                </div>
                <div style="position: absolute;bottom:20px;left:39%;" v-if="item.isSaleout">
                  <img src="../../assets/image/soldout.svg" width="65">
                </div>
              </div>
            </div>
          </div>
          <div style="height: 60px;"></div>
        </scroller>
      </div>
      <!--底部-->
      <div class="footer-recommend flex-layout">
        <div class="menu-bt-recommend magin-l-10" @click="clickOrder()">
          <img src="../../assets/image/arrow-left.png" width="30" height="30" style="vertical-align: middle">
        </div>
        <div class="menu-bt1-recommend magin-r-10" :style="carStyle(orderedTotal)" @click.stop="clickOrdered()" >
          <div class="color-yellow" v-if="orderedTotal.amount>0">{{orderedTotal.amount}}元</div>
          <img src="../../assets/image/cart.png" width="30" height="30" style="vertical-align: middle">
          <span class="carQty font-0-6" v-if="orderedTotal.count>0">{{orderedTotal.count}}</span>
        </div>
      </div>
      <ordered ref="ordered" :boxshow="isShowOrdered()" :back-order="backRecommend"></ordered>
      <nosuitMode ref="nosuitMode"></nosuitMode>
      <alertnum ref="alertnum"></alertnum>
    </div>
  </transition>
</template>
<script>
  import ServiceHttp from "../../service/ServiceHttp";
  import ServiceUtils from "../../service/ServiceUtils";
  import ordered from "../ordered/ordered";
  import alertnum from '../alertnum/alertNum';

  import ServiceDialog from "../../service/ServiceDialog";
  import nosuitmode from "../noSuitMode/nosuitmode";
  export default {
    name: "recommend",
    data(){
      return{
        orderedTotal:ServiceUtils.orderedTotal,//点菜概况

        showOrderd:false, //已点单参数
        recommendMenu:[]
      }
    },
    components:{
      'nosuitMode':nosuitmode,
      'alertnum':alertnum,
      'ordered':ordered
    },
    props:{
      show:{
        type:Boolean,
        default:false
      },
      hide:{
        type: Function,
        default: null
      }
    },
    methods:{
      /**
       * 获取推荐菜
       * */
      initRecommendData:function () {
        ServiceHttp.getRecommendMenu(res=>{
          if(res){
            res.forEach((type)=>{
              type.menuItem = [] ;
              type.items.forEach((item)=>{
                if(ServiceUtils.menuItemDataMap[item.itemcode]){
                  type.menuItem.push(ServiceUtils.menuItemDataMap[item.itemcode])
                }
              });
            });
            this.recommendMenu.length = 0;
            this.recommendMenu = res;
            console.log('组件内的数据组装了,',res)
          }
        });
      },
      clickDetail:function(order){
        if(order.isSaleout) return;
        order.num = 1;
        let type = order.type;
        if(order.memoflag==1){
          //呼叫配菜
          this.$refs.nosuitMode.togglebox(type,order);
        }else if(order.remark.length>0){
          //有加菜项
          this.$refs.nosuitMode.togglebox(type,order);
        }else if(order.picMode!==0){
          //有图
          this.$refs.nosuitMode.togglebox(type,order);
        }else if(order.standards.length>1){
          //多规格
          this.$refs.nosuitMode.togglebox(type,order);
        }else {
          //弹框点菜
          this.$refs.alertnum.togglebox(type,order,function(food){
            let type = {
              code:food.code,
              name:food.name,
              ename:food.sndname||"",
              isGroup:0
            };
            let order = food.menuItem;
            ServiceUtils.setNoSuitData(type,order);
          });
        }
      },
      /**
       * 返回点菜
       * */
      clickOrder(){
        if(this.hide){this.hide();}
      },
      /**
       * 购物车有数据 样式加宽
       * */
      carStyle(orderedTotal){
        if(orderedTotal.amount > 0){
          return "width :115px"
        }else {
          return "width :45px"
        }
      },

      /**
       * 点击已点菜
       */
      clickOrdered(){
          this.showOrderd = true;
      },
      /**
       * 控制显示是否展示已点清单
       * */
      isShowOrdered(){
        return this.showOrderd;
      },
      /**
       * ordered返回的函数
       */
      backRecommend: function(){
        this.showOrderd = false;
      },
    },
    mounted(){
      let params = this.$route.params ;      //url参数
      ServiceUtils.config.sellerId = params.sellerId;
      ServiceUtils.config.storeId = params.storeId;
      ServiceUtils.config.orderType = params.orderType;
      if(ServiceUtils.config.orderType==0 || ServiceUtils.config.orderType==1){ //堂食和自提用 堂食菜谱
        ServiceUtils.config.menuClass = 0;
      }else{ //用外卖菜谱
        ServiceUtils.config.menuClass = 1;
      }
      if(ServiceUtils.menuData.length>0){
        this.initRecommendData();
      }
    },

  }
</script>

<style scoped lang="scss">
  @import "../../assets/css/style";
  .magin-l-10{
    margin-left: 10px;
  }
  .magin-r-10{
    margin-right: 10px;
  }
  .recommend{
    position: fixed;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color:#7b6e52 ;
  }
  .footer-recommend{
    position: fixed;
    height: 60px;
    width: 100%;
    bottom: 0;
    left: 0;
    /*background-color: rgba(0, 0, 0, 0.7);*/
    flex-direction: row;
    justify-content: space-between;
    color: white;
  }
  .menu-bt-recommend{
    width: 45px;
    height: 45px;
    border-radius: 30px;
    background-color: rgba(0, 0, 0, 0.7);
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .carQty{
    position: absolute;
    top:3px;
    right: 5px;
    width: 20px;
    height: 20px;
    background: red;
    border-radius: 10px;
    text-align: center;
    line-height: 20px;
  }
  .menu-bt1-recommend{
    width: 45px;
    height: 45px;
    border-radius: 30px;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }
  .recommend-content{
    position: absolute;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .top-Nav{
    display: flex;
    flex: 1;
    background-color: #fff;
    border-radius: 6px;
    text-align: center;
    margin: 10px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 3px 0;
  }
  .nav-Row{
    width: auto;
    padding: 0 2px;
  }
  .nav-Row img{
    width: 60px;
    pointer-events: none;
  }
  .recom-Con{
    display: flex;
    flex: 1;
    background-color: #fff;
    border-radius: 6px;
    text-align: center;
    margin: 20px 10px 15px 10px;
    flex-direction: column;
    justify-content: flex-start;
    position: relative;
  }
  .recom-title{
    flex: 1;
    height: 45px;
    line-height: 45px;
    background-color: #f0cf8e;
    text-align: center;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-image: url("../../assets/image/oceanbg.svg");
    background-repeat: repeat-x;
    background-position: 0 100%;
    background-size: 12px;
  }
  .recom-Icon{
    width: 50px;
    height: 50px;
    border-radius: 100%;
    position: absolute;
    top: -10px;
    left: 10px;
    background-color: #fff;
    display: flex;
    justify-content: center;
  }
  .recom-Icon img{
    width: 70%;
    align-self: center;
  }
  .reason{
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: flex-start;
    margin: 10px;
    background-color: #fffcf6;
  }
  .reason-row{
    text-align: left;
    padding: 10px;
  }
  .food-content{
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: flex-start;
    margin: 0 10px 10px 10px;
  }
  .food-mainInfo{
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: flex-start;
    padding: 5px;
  }
  .food-nopic{
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: flex-start;
  }
  .food-nopic-title{
    flex: 1;
    padding: 10px 5px 5px 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }
  .food-nopic-title img{
    vertical-align: middle;
    pointer-events: none;
  }
  .food-pic{
    width: 100px;
    height: 79px;
    overflow: hidden;
    display: flex;
  }
  .food-pic img{
    width: 100px;
    height: 79px;
    align-self: center;
  }
  .food-Name{
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 10px;
    text-align: left;
  }
  .food-Name-row{
    flex: 1;
  }
  .food-Name-row img{vertical-align: middle;pointer-events: none;}

  .food-Name-tips{
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }
  .price-Content{
    background-color: #f6f6f6;
    display: flex;
    flex: 1;
    height: 34px;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 6px;
    padding: 3px 10px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top:0.5px solid #dddddd;
  }
  .price-One{
    width: auto;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .price-One img{
    align-self: center;
    pointer-events: none;
  }

  .price-One span{
    align-self: center;
  }
  .view-info{
    background-color: #fff;
    padding: 5px 18px;
    align-self: center;
  }

  .font1-4{
    font-size: 1.4em;
  }

  .font1-3{
    font-size: 1.3em;
  }

  .font1-2{
    font-size: 1.2em;
  }

  .font1-1{
    font-size: 1.1em;
  }

  .font0-9{
    font-size: 0.9em;
  }

  .font0-8{
    font-size: 0.8em;
  }

  .line-right-lightYellow{
    border-right:0.5px solid #e1dcc9;
  }

  .border-brown{
    border:0.5px solid #e1dcc9;
  }

  .border-radius-5{
    border-radius: 5px;
  }

  .color-orange{
    color: #ff7800;
  }

  .border-radius-30{
    border-radius: 30px;
  }

  .border-gray{
    border:0.5px solid #dddddd;
  }

  .color-lightGray{
    color: #bababa;
  }

  .width30{
    width: 30px;
  }
  .flex-layout{ display: flex;  align-items: center;}

  .height-36{
    height: 36px;
    overflow: hidden;
  }
  .order_identifying{position: absolute;top: 0;right: 0;color: #fff;border-width: 10px;}

</style>



// WEBPACK FOOTER //
// src/components/recommend/recommend.vue